import React, { Component } from 'react';
import { shanehList, densitiesList } from '../../../settings';


export default class RugDensities extends Component {

    // this.props.selectedBrands.indexOf(brand.id) !== -1

    constructor(props) {
        super(props)
        this.state = {
            densities: [],
        }
    }

    getDensities = (shanehs) => {
        if (shanehs.length === 0) { return densitiesList }

        let densities = []
        shanehs.forEach(shaneh => {
            shanehList[shaneh].forEach(density => {
                if (densities.indexOf(density) === -1) {
                    densities.push(density)
                }
            })
        });
        return densities
    }

    render() {
        return (
            <div className={this.props.activeFilters.indexOf("densities") !== -1 ? "items-body active" : "items-body"}>
                <div className="d-grid">
                    {this.getDensities(this.props.selectedShanehs).map((density, i) =>
                        <label className="filter-effect-input" key={density + i}>
                            {density}
                            <input type="checkbox" checked={this.props.selectedDensities.indexOf(density) !== -1} onChange={() => this.props.changeHandler("densities", density)} />
                            <span className="checkmark"></span>
                        </label>
                    )}
                </div>
            </div>
        )
    }
}